import * as React from "react";
import PropTypes from "prop-types";

const propTypes = {
	children: PropTypes.node.isRequired,
	selectedTab: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	customStyle: PropTypes.object
};

const defaultProps = {
	customStyle: {}
};

const CBTabPanel = (props) => {
	const { children, value, selectedTab, customStyle } = props;

	return value === selectedTab ? <div style={customStyle}>{value === selectedTab && children}</div> : <></>;
};

CBTabPanel.propTypes = propTypes;
CBTabPanel.defaultProps = defaultProps;

export default CBTabPanel;
